import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewComfyAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_comfy_alt"}/>
}
